<p-slider
  [range]="formField.range || false"
  [min]="formField.min"
  [max]="formField.max"
  class="pm-form-field-slider"
  [formControl]="sliderCtrl"
/>
